import { render, staticRenderFns } from "./workStandardDetail.vue?vue&type=template&id=286f5c5c"
import script from "./workStandardDetail.vue?vue&type=script&lang=js"
export * from "./workStandardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286f5c5c')) {
      api.createRecord('286f5c5c', component.options)
    } else {
      api.reload('286f5c5c', component.options)
    }
    module.hot.accept("./workStandardDetail.vue?vue&type=template&id=286f5c5c", function () {
      api.rerender('286f5c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/sws/workStandardDetail.vue"
export default component.exports